 <template>

   <!--新版本打赏弹窗8-20-->
   <div class="alert-box reward-alert-new" :class="cdCls">
     <p class="mask" @click="closeRewardFun(false)" v-if="res.noReward!=2||res.isReward==true||bagInfo.price!=0"></p>
     <p class="mask" v-else></p>
     <div class="alert-con" v-if="bagtype=='sm'">
       <div class="alert-info border-box">
         <div class="video-info clearfix">
           <img class="img-sm" src="../assets/sm-ds.png" />
           <div class="video-title">
             <p class="video-info-title hide">讲得非常的好！</p>
             <p class="video-info-sub hide">共有{{bagInfo.dsnum}}人随喜，支持鼓励！</p>
           </div>
           <!--打赏人头像-->
           <div class="reward-person-box clearfix">
             <p v-for="(item,index) in dsImgs"  v-if='index<7' class="reward-person" ref="Person"><img class="img" :src="item.img" /></p>
           </div>
           <!--打赏金额-->
           <div class="reward-money-type clearfix">
             <span @click="clickFixedNum(50)" :data-price="50" class="hide" v-bind:class="{ curr:50==currentPrice}">￥50</span>
             <span @click="clickFixedNum(20)" :data-price="20" class="hide" v-bind:class="{ curr:20==currentPrice}">￥20</span>
             <span @click="clickFixedNum(10)" :data-price="10" class="hide" v-bind:class="{ curr:10==currentPrice}">￥10</span>
             <span @click="clickFixedNum(5)" :data-price="5" class="hide" v-bind:class="{ curr:5==currentPrice}">￥5</span>
           </div>
           <!--土豪随意-->
           <div class="reward-money-input border-box clearfix">
             <span class="fl">随喜金额：</span>
             <input class="fl" placeholder='施主请随意' maxlength="5" type="number" @keydown="handleInput2" number v-model.number="inputPrice" v-on:input="inputNum(inputPrice)"/>
           </div>
         </div>
         <!--<p @click="closeRewardFun(false)" class="btn-pay btn-pay1">听听再说</p>-->
         <p @click='payDSOrder' class="btn-pay">随喜￥{{currentPrice}}</p>
       </div>
     </div>
     <div class="alert-con" v-else>
       <!--<img @click="closeRewardFun(false)" class="icon-close" src="../assets/icon-close.png" />-->
       <div class="alert-info border-box">
         <div class="video-info clearfix">
           <div class="video-info-img-box">
             <p class="gray-mask"></p>
             <p class="video-info-img border-box">
               <img class="img" :src="bagInfo.guideheadimg2?bagInfo.guideheadimg2:bagInfo.guideheadimg" />
             </p>
           </div>
           <div class="video-title">
             <p class="video-info-title hide">“{{bagInfo.guidename2?bagInfo.guidename2:bagInfo.guidename}}”真是讲的太好啦！</p>
             <p class="video-info-sub hide">共有
               <span style="color:#FF9C06">{{bagInfo.dsnum}}</span> 人打赏
             </p>
           </div>
           <!--打赏人头像-->
           <div class="reward-person-box clearfix">
             <p v-for="(item,index) in dsImgs"  v-if='index<12' class="reward-person" ref="Person"><img class="img" :src="item.img" /></p>
           </div>
           <!--打赏金额-->
           <div class="reward-money-type clearfix">
             <span @click="clickFixedNum(10)" :data-price="10" class="hide" v-bind:class="{ curr:10==currentPrice}">10元</span>
             <span @click="clickFixedNum(8)" :data-price="8" class="hide" v-bind:class="{ curr:8==currentPrice}">8元</span>
             <span @click="clickFixedNum(5)" :data-price="5" class="hide" v-bind:class="{ curr:5==currentPrice}">5元</span>
             <span @click="clickFixedNum(2)" :data-price="2" class="hide" v-bind:class="{ curr:2==currentPrice}">2元</span>
           </div>
           <!--土豪随意-->
           <div class="reward-money-input border-box clearfix">
             <span class="fl">打赏金额：</span>
             <input class="fl" placeholder='土豪请随意' maxlength="5" type="number" @keydown="handleInput2" number v-model.number="inputPrice" v-on:input="inputNum(inputPrice)"/>
           </div>
         </div>
         <p @click='payDSOrder' class="btn-pay" v-if="res.noReward!=2||res.isReward==true||bagInfo.price!=0">立即打赏{{currentPrice}}元</p>
         <p @click='payDSOrder' class="btn-pay" v-else>打赏{{currentPrice}}元  继续收听</p>
       </div>
     </div>
   </div>

</template>

 <script>

   import {creatDSOrder,listenVideo} from '@/utils/wechat'

   import D from '@/wc-messagebox'
   import Vue from 'vue'
   Vue.use(D)

   export default {
     data(){
       return{
         height: '', //打赏人
         currentPrice:5,//选项卡
         inputPrice:'',//input框值,
         rewardClose:0//弹窗关闭
       }
     },
     created(){
       if(this.bagtype=='sm'){
         this.currentPrice=10;
       }
     },
     props: ['bagInfo','dsImgs','bagtype','res','that'],
     computed: {
       cdCls() {
         var cla
         if(this.bagtype == 'sm'){
           cla = 'sm'
         }
         return cla
       }
     },
     mounted () {

     },
     methods: {

       handleInput2(e) {
         // 通过正则过滤小数点后两位
         e.target.value = e.target.value.replace(/[^\d]/g,'');
       },

       clickFixedNum(item){
         this.currentPrice=item;
         this.inputPrice = ''
       },

       inputNum(inputPrice){
         this.currentPrice = inputPrice;
         if(inputPrice==''||inputPrice==undefined){
           this.currentPrice = 10
         }
       },

       //提交打赏订单
       payDSOrder(){
         let self = this;
         if(self.currentPrice<1){
           self.$toast('打赏金额不小于1元');
         } else if(self.currentPrice>2000){
           self.$toast('打赏金额不大于2000元');
         } else {
           creatDSOrder(self,self.bagInfo.id,self.currentPrice,function(data){
             if(data){
               self.clickFixedNum(10);
               self.closeRewardFun(true);
               self.res.isReward = true;
               if(this.res.isbuy){
                 listenVideo(self.that,self.global.currIndex);
               }
             }
           });
         }
       },

       closeRewardFun:function(success){
         if(success){
           this.$emit('child-Reward',{rewardShow: this.rewardClose, success: true});
         }else {
           this.$emit('child-Reward',{rewardShow: this.rewardClose, success: false});
         }
       },
     },

   }
 </script>


  <style scoped>

    @import '../style/alert';

    .reward-alert-new.sm .alert-con{ text-align: center; background: #fff url(../assets/sm-shade.png) repeat; }
    .reward-alert-new.sm .video-info{ margin-top: 0; }
    .reward-alert-new.sm .img-sm{ width: 16.8%; margin: .45rem auto 0; }
    .reward-alert-new.sm .video-title{ margin-top: .12rem; }
    .reward-alert-new.sm .video-info-title{ font-size: .4rem; color: #000; }
    .reward-alert-new.sm .video-info-sub{ font-size: .28rem; }
    .reward-alert-new.sm .reward-person-box{ margin: .24rem .55rem 0; height: 1.7rem; text-align: center; }
    .reward-alert-new.sm .reward-person-box .reward-person{ float: none;display: inline-block; width: .61rem; height: .61rem; margin: 0 0 .16rem -.05rem; border-radius: 100%; overflow: hidden; }
    .reward-alert-new.sm .reward-money-type { margin: .3rem .55rem 0; }
    .reward-alert-new.sm .reward-money-type span{ font: bold .32rem/.64rem "Microsoft YaHei"; color: #796042; border-radius: .64rem;outline:none; background-color: rgba(121,96,66,.15); }
    .reward-alert-new.sm .reward-money-type span.curr{ background: #796042; color: #fff; }
    .reward-alert-new.sm .reward-money-input{margin: .24rem .53rem 0;padding-left: 0; }
    .reward-alert-new.sm .reward-money-input input{ left: 1.5rem; background: rgba(255,255,255,0); }
    .reward-alert-new.sm .btn-pay{ /*display: inline-block; width: 37%;*/ margin: .32rem .32rem 0; height: .82rem; line-height: .82rem; border: .03rem solid #796042; background-color: #796042; }
    .reward-alert-new.sm .btn-pay1{ color: #796042; border-color: #e3e3e3; background-color: rgba(0,0,0,0); }

  </style>



// WEBPACK FOOTER //
// src/components/AlertReward.vue